var map = {
	"./App": 4180,
	"./App.vue": 4180,
	"./assets/SeekPng.com_valero-logo-png_6270479.png": 7345,
	"./assets/SeekPng.com_world-map-png_227545.png": 6625,
	"./assets/blob-bg.png": 9378,
	"./assets/blob.svg": 9898,
	"./assets/coming.svg": 5749,
	"./assets/companies/grab.svg": 255,
	"./assets/companies/ray-ban.svg": 5254,
	"./assets/companies/slack-new.svg": 2178,
	"./assets/companies/slack.svg": 6478,
	"./assets/companies/spotify.svg": 3728,
	"./assets/companies/tunein.svg": 7752,
	"./assets/global.css": 8645,
	"./assets/icons/browser.svg": 9805,
	"./assets/icons/coffee.png": 721,
	"./assets/icons/folder.svg": 8470,
	"./assets/icons/hyperloop-512.png": 4527,
	"./assets/icons/money-bag-512.png": 4649,
	"./assets/icons/money.svg": 4613,
	"./assets/icons/rocket.svg": 9614,
	"./assets/icons/team-512.png": 5770,
	"./assets/icons/team.svg": 101,
	"./assets/icons/wallet.svg": 3740,
	"./assets/image-1.png": 6871,
	"./assets/image-2.png": 9267,
	"./assets/image-2.svg": 3130,
	"./assets/image-3.png": 3628,
	"./assets/logo.png": 6949,
	"./assets/logo.svg": 9574,
	"./assets/products/beauty-picks.png": 1088,
	"./assets/products/box.png": 4560,
	"./assets/products/clock.png": 4769,
	"./assets/products/headset.png": 4332,
	"./assets/products/macbook.png": 5222,
	"./assets/products/pressure-cooker.png": 7977,
	"./assets/products/puppy.png": 1591,
	"./assets/products/shoes-1.png": 9926,
	"./assets/products/shoes-2.png": 1016,
	"./assets/products/shoes-3.png": 7890,
	"./assets/products/shoes.png": 1142,
	"./assets/products/vr.png": 7644,
	"./assets/products/webp/beauty-picks.webp": 6036,
	"./assets/products/webp/clock.webp": 1942,
	"./assets/products/webp/headset.webp": 1035,
	"./assets/products/webp/macbook.webp": 8957,
	"./assets/products/webp/pressure-cooker.webp": 7183,
	"./assets/products/webp/puppy.webp": 7772,
	"./assets/products/webp/shoes-1.webp": 6800,
	"./assets/products/webp/shoes.webp": 3795,
	"./assets/products/webp/vr.webp": 9893,
	"./assets/products/webp/xbox-controller.webp": 2366,
	"./assets/products/xbox-controller.png": 6941,
	"./assets/team.jpg": 1663,
	"./assets/team/1.jpg": 9265,
	"./assets/team/2.jpg": 4759,
	"./assets/team/3.jpg": 7900,
	"./assets/team/4.jpg": 684,
	"./assets/world-map.png": 1247,
	"./components/LoaderView": 5071,
	"./components/LoaderView.vue": 5071,
	"./components/NotFound": 2279,
	"./components/NotFound.vue": 2279,
	"./components/Snackbar": 8555,
	"./components/Snackbar.vue": 8555,
	"./components/app/Footer": 6642,
	"./components/app/Footer.vue": 6642,
	"./components/app/Navbar": 8643,
	"./components/app/Navbar.vue": 8643,
	"./components/app/components/Favorites": 7673,
	"./components/app/components/Favorites.vue": 7673,
	"./components/app/components/SearchBar": 2056,
	"./components/app/components/SearchBar.vue": 2056,
	"./components/app/components/ShoppingCart": 5083,
	"./components/app/components/ShoppingCart.vue": 5083,
	"./components/home/Card": 1420,
	"./components/home/Card.vue": 1420,
	"./components/home/CardsContainer": 5879,
	"./components/home/CardsContainer.vue": 5879,
	"./components/home/ClientsSection": 3907,
	"./components/home/ClientsSection.vue": 3907,
	"./components/home/FirstSection": 9222,
	"./components/home/FirstSection.vue": 9222,
	"./components/home/NewsletterInput": 1976,
	"./components/home/NewsletterInput.vue": 1976,
	"./components/home/OfferCard": 7810,
	"./components/home/OfferCard.vue": 7810,
	"./components/home/OffersSection": 4730,
	"./components/home/OffersSection.vue": 4730,
	"./components/home/OurSkills": 7489,
	"./components/home/OurSkills.vue": 7489,
	"./components/home/QuoteSection": 4304,
	"./components/home/QuoteSection.vue": 4304,
	"./components/home/TeamMemberCard": 1763,
	"./components/home/TeamMemberCard.vue": 1763,
	"./components/home/TeamSection": 5666,
	"./components/home/TeamSection.vue": 5666,
	"./components/home/TitleDescription": 5905,
	"./components/home/TitleDescription.vue": 5905,
	"./components/home/WhySection": 8511,
	"./components/home/WhySection.vue": 8511,
	"./components/shop/CategoryCard": 2214,
	"./components/shop/CategoryCard.vue": 2214,
	"./components/shop/ComfyStyles": 514,
	"./components/shop/ComfyStyles.vue": 514,
	"./components/shop/DealsAndPromotions": 7828,
	"./components/shop/DealsAndPromotions.vue": 7828,
	"./components/shop/HeroSlider": 3026,
	"./components/shop/HeroSlider.vue": 3026,
	"./components/shop/ProductCard": 2034,
	"./components/shop/ProductCard.vue": 2034,
	"./components/shop/ProductsContainer": 1032,
	"./components/shop/ProductsContainer.vue": 1032,
	"./components/shop/RecommendationCard": 9467,
	"./components/shop/RecommendationCard.vue": 9467,
	"./components/shop/RecommendationContainer": 8848,
	"./components/shop/RecommendationContainer.vue": 8848,
	"./components/shop/ShopByCategories": 607,
	"./components/shop/ShopByCategories.vue": 607,
	"./components/shop/SliderProduct": 5650,
	"./components/shop/SliderProduct.vue": 5650,
	"./main": 866,
	"./main.js": 866,
	"./plugins/vuetify": 9821,
	"./plugins/vuetify.js": 9821,
	"./router": 1120,
	"./router/": 1120,
	"./router/index": 1120,
	"./router/index.js": 1120,
	"./store": 4239,
	"./store/": 4239,
	"./store/index": 4239,
	"./store/index.js": 4239,
	"./views/Checkout": 3617,
	"./views/Checkout.vue": 3617,
	"./views/ComingSoon": 6074,
	"./views/ComingSoon.vue": 6074,
	"./views/HomeView": 7902,
	"./views/HomeView.vue": 7902,
	"./views/ProductDetails": 7053,
	"./views/ProductDetails.vue": 7053,
	"./views/ProductsByCategory": 2429,
	"./views/ProductsByCategory.vue": 2429,
	"./views/Search": 89,
	"./views/Search.vue": 89,
	"./views/ShopView": 6228,
	"./views/ShopView.vue": 6228
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8116;